import { executeRequest, JFSRequest } from '@jfs/network'
import { isSuccessResponse } from '../utils'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'

const responseParser = (response: any) => {
  return isSuccessResponse(response)
}
// /package-mid/getMids?mid=12345
const getVerifiedMId = (mid: string, tokens: any, fileType) => {
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.routingMid2PackMerchantVerify),
    method: 'GET',
    cache: false,
    config: sitConfig(tokens),
    headers: getHeaders(),
    body: {
      mid,
      fileType
    },
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { getVerifiedMId }
